import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';

import { ColumnCell } from 'modules/_shared/Table/types/ColumnCell';
import TableHeader from 'modules/_shared/Table/components/TableHeader';
import { useEncumbranceDetailsPage } from '../context/EncumbranceDetailsPageContext';

const CoOwnersTableHeader: FC = () => {
  const { t } = useTranslate();

  const { data } = useEncumbranceDetailsPage();

  const hasOptions = !data.isReadOnly && data.isAdmin;

  const columns = [
    { key: 'expand', content: '', className: 'coOwners-table__expand-col' },
    { key: 'co-owner-name', content: t('Name') },
    { key: 'cif', content: t('Cif') },
    { key: 'email', content: t('Email') },
    { key: 'percent', content: t('Percent'), textPosition: 'right' },
    hasOptions ? { key: 'actions', content: '' } : null,
  ].filter(Boolean) as ColumnCell[];

  return <TableHeader columns={columns} />;
};

export default CoOwnersTableHeader;
